/**
 * Clave secreta usada para validar el token en la URL.
 */
const SECRET_KEY = 'PAS.X!MX4J';

/**
 * Desencripta un token de URL (formato Base64 de "CLAVE|ID")
 * Devuelve el ID original como string.
 */
export function decryptId(token: string): string | null {
	try {
		// Revertimos los reemplazos de URL-safe Base64
		let base64 = token
			.replace(/-/g, '+')
			.replace(/_/g, '/');
		
		// Añadir padding si falta
		const pad = base64.length % 4;
		if (pad === 2) base64 += '==';
		else if (pad === 3) base64 += '=';

		// Decodificamos el Base64 (usamos atob o CryptoJS)
		const decoded = atob(base64); // "PAS.X!MX4J|1714049"
		
		// Verificamos que contenga el separador y la clave
		if (decoded.includes('|')) {
			const parts = decoded.split('|');
			const key = parts[0];
			const id = parts[1];

			if (key === SECRET_KEY) {
				return id;
			}
		}
		
		return null;
	} catch (error) {
		console.error('Error decodificando token:', error);
		return null;
	}
}

/**
 * Función para generar tokens con este nuevo formato si lo necesitas en el front
 */
export function encryptId(value: number | string): string {
	const str = `${SECRET_KEY}|${value}`;
	const base64 = btoa(str);
	return base64
		.replace(/\+/g, '-')
		.replace(/\//g, '_')
		.replace(/=/g, '');
}
